import * as type from '../../../actions/index.types'

export function CtrlProfileReducers(state = {
    loading: false,
    ProfileData: {},
    // Bumped on every successful password change so the profile form knows to
    // clear the typed-in credentials. A timestamp (not a boolean) so two
    // consecutive changes still fire the effect.
    passwordChangedAt: null,
    error: null
}, action) {

    switch (action.type) {

        case type.CTRL_GET_PROFILE:
            return {
                ...state,
                loading: true,
                error: null,
            }

        case type.CTRL_GET_PROFILE_SUCCESS:
            return {
                ...state,
                error: null,
                loading: false,
                ProfileData: action.payload,
            }

        case type.CTRL_GET_PROFILE_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        case type.CTRL_UPDATE_PROFILE:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.CTRL_UPDATE_PROFILE_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
            }
        }
        case type.CTRL_UPDATE_PROFILE_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        case type.CTRL_CHANGE_PASSWORD:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.CTRL_CHANGE_PASSWORD_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                passwordChangedAt: Date.now(),
            }
        }
        case type.CTRL_CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }


        default:
            return state
    }
}